angular
  .module("myApp")
  .controller("DialogHelper", ($scope, Codifiers) => {
    $scope.Codifiers = Codifiers
    $scope.kla = Codifiers.kla
    $scope.editMode = true
    return _.each($scope.ngDialogData, (v, k) => {
      if (k !== "ngDialogId") {
        $scope[k] = v
      }
    })
  })
  .service("Dialog", function (ngDialog, Notification, $q) {
    const isDismissal = (action) => {
      return action === undefined || ["$document", "$closeButton", "$escape"].includes(action)
    }

    this.finish = (obj, reload_fn, title) => {
      let promise

      if (typeof obj === "function") {
        const ret = $q.defer()
        obj(ret.resolve, ret.reject)
        promise = ret.promise
      } else if (obj.id) {
        promise = obj.$save()
      } else {
        promise = obj.$create()
      }

      return promise.then(
        (res) => {
          Notification.success(title || "Izmaiņas saglabātas")
          if (reload_fn) {
            reload_fn()
          }
          return res
        },

        (e) => {
          Notification.error(e.data)
          throw e
        }
      )
    }

    this.dialog = (template, obj, opts, callback) => {
      if (callback === void 0) {
        callback = opts
        opts = {}
      }
      const width = opts.width || (opts.wide ? 1000 : 750)

      const dlg = ngDialog.open({
        template,
        width,
        controller: "DialogHelper",
        className: "ngdialog-theme-default",
        trapFocus: false,
        preserveFocus: true,
        preCloseCallback: (action) => {
          obj.error = void 0
          if (isDismissal(action)) {
            return true
          }
          if (!callback) {
            return true
          }
          const ret = callback(obj, action)
          if (ret === void 0) {
            return true
          }
          if (ret === true) {
            return true
          }
          if (ret && typeof ret.then === "function") {
            ret.catch((reason) => {
              obj.error = reason.data || reason
            })
          }
          return ret
        },
        data: {
          dto: obj,
        },
      })
      return dlg.closePromise.then((d) => {
        const v = d.value
        if (v === "$escape" || v === "$closeButton") {
          return
        }
        return v
      })
    }
    return this
  })
